import ApiAdmin from './config/ApiAdmin'
import store from '@/store/index'

const PlayersService = {

  getPlayers (page, pageSize, search) {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/players`,
      {params: {page, page_size: pageSize, search}})
  },

  getPlayersOnline () {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/online`)
  },

  getPlayer (id, slug) {
    return ApiAdmin.get(`/organizations/${slug || store.getters.slug}/players/${id}`)
  },

  createPlayer (player, slug) {
    return ApiAdmin.post(`/organizations/${slug || store.getters.slug}/players`, player)
  },

  getAll (search) {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/players`, {params: {search: search}})
  },

  editPlayer (player) {
    return ApiAdmin.put(`/organizations/${store.getters.slug}/players/${player.id}`,
      player)
  },

  deletePlayer (playerId) {
    return ApiAdmin.delete(`/organizations/${store.getters.slug}/players/${playerId}`)
  },

  getPlayersByGroupId (groupId, page, pageSize, search) {
    return ApiAdmin.get(`/groups/${groupId}/players`,
      {params: {page, page_size: pageSize, search}})
  },

  removePlayerFromGroup (groupId, playerId) {
    return ApiAdmin.delete(`/groups/${groupId}/players/${playerId}`)
  },

  addPlayerToGroup (groupId, playerId) {
    return ApiAdmin.put(`/groups/${groupId}/players/${playerId}`)
  }

}

export default PlayersService



// WEBPACK FOOTER //
// ./src/services/PlayersService.js